import useGetMemberCompany from "#/components/company/hooks/useGetMemberCompany"

const RTX_SALESFORCE_ID = "0011U00001kiHTaQAM" as const
const UPENN_SALESFORCE_ID = "0011U000013AaqtQAC" as const

export function useCustomNetworkCustomer() {
  const memberCompany = useGetMemberCompany()
  const salesforceAccountId = memberCompany?.data?.salesforceAccountId

  return {
    isRtxSegment: salesforceAccountId === RTX_SALESFORCE_ID,
    isUPennSegment: salesforceAccountId === UPENN_SALESFORCE_ID
  }
}
